import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const generateMakeoverDoc = createAsyncThunk("ListingMakeover/generateMakeoverDoc", async (data, thunkAPI) => {
  try {
    const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}api/transactions/makeover/document/generate/${data.id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return {...resp.data,id:data.id};
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
